import { createFileRoute, redirect } from '@tanstack/react-router';

import { z } from 'zod';

export const Route = createFileRoute('/_secured')({
  validateSearch: z.object({
    next: z.string().optional().catch(''),
    workspace: z.string().optional().catch(''),
  }),
  async beforeLoad({ context, location }) {
    if (!(await context.isAuthenticated())) {
      console.log('redirecting to login from secured route');
      throw redirect({
        to: '/login',
        search: {
          next: location.pathname,
        },
      });
    }
  },
  async loader({ context }) {
    await context.getInstance('i18n', '@mint-admin/secured-layout');
    await context.getInstance('http', 'defaultApi');
  },
});
